import React from 'react';
import { Content, LeftSide, Title, Text, Icon, RightSide } from '../styles';
import SVGIcon from '../../../../assets/images/svg/SVGIcon';
import { ICON_SIZE } from '../../../../global/constants';

const FilesEmptyState: React.FC = () => {
  return (
    <Content>
      <LeftSide>
        <Title>You have no Files</Title>
        <Text>Tap + to add new files and documents</Text>
        <Icon>
          <SVGIcon
            name='updated-file-icon'
            width='21'
            height='21'
            viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
            fill='var(--text-secondary)'
          />
          <SVGIcon
            name='filescreen-dropdown-folder-icon'
            width='21'
            height='21'
            viewBox={`0 0 ${ICON_SIZE.MD} ${ICON_SIZE.MD}`}
            fill='var(--text-secondary)'
          />
          <SVGIcon
            name='google-drive-icon'
            width='21'
            height='21'
            viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
            fill='var(--text-secondary)'
          />
          <SVGIcon
            name='dropbox-icon'
            width='21'
            height='21'
            viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
            fill='var(--text-secondary)'
          />
          <SVGIcon
            name='onedrive-icon'
            width='21'
            height='21'
            viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
            fill='var(--text-secondary)'
          />
        </Icon>
      </LeftSide>
      <RightSide>
        <SVGIcon name='wireframe-icon' width='79' height='80' viewBox='0 0 79 80' className='web-view' />
        <SVGIcon name='wireframe-mobile-icon' width='88' height='64' viewBox='0 0 88 64' className='mobile-view' />
      </RightSide>
    </Content>
  );
};

export default FilesEmptyState;
